import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import GlobalSnackbar from "../../../../shared/utils/GlobalSnackbar";
import AddIcon from "@mui/icons-material/Add";
import CapitaliseWords from "../../../../shared/utils/CapitaliseWords";
import GlobalButton from "../../../../shared/utils/GlobalButton";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Chip,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import Styles from "../../../../styles/vendorDashboard.module.css";
import styles from "../../../../styles/adminPortal.module.css";

import PaymentDialog from "./VendorPaymentDialog";
import GlobalDropdownField from "../../../../shared/utils/GlobalDropdownField";

const headCells = [
  {
    id: "campaign",
    label: "Campaign",
    width: 200,
  },
  {
    id: "clusterTitle",
    label: "Cluster Title",
    width: 200,
  },

  {
    id: "vpname",
    label: "Vendor Name",
    width: 200,
  },
  {
    id: "organisationname",
    label: "Organisation Name",
    width: 200,
  },
  {
    id: "serviceType",
    label: "Service Type",
    width: 160,
  },
  {
    id: "jobtimeline",
    label: "Job Timeline",
    width: 160,
  },

  {
    id: "completion",
    label: "Completion",
    width: 140,
  },

  {
    id: "paymentdone",
    label: "Payment Done",
    width: 160,
  },
  {
    id: "action",
    label: "Action",
    width: 160,
  },
];

function EnhancedTableHead(props) {
  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {headCell.id === "campaign" && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder="Search Campaign"
                  onChange={(e) =>
                    props.handleSearchChangeHead(e, "campaignTitle")
                  }
                  value={props.searchInputs?.campaignTitle || ""}
                />
              )}
              {headCell.id === "vpname" && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder="Search Vendor Name"
                  onChange={(e) => props.handleSearchChangeHead(e, "ownerName")}
                  value={props.searchInputs?.ownerName || ""}
                />
              )}
              {headCell.id === "organisationname" && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder="Search Business Name"
                  onChange={(e) =>
                    props.handleSearchChangeHead(e, "vendorBusinessName")
                  }
                  value={props.searchInputs?.vendorBusinessName || ""}
                />
              )}
              {headCell.id === "serviceType" && (
                <GlobalDropdownField
                  name="serviceTypeFilter"
                  variant="searchDropdown"
                  value={props.searchInputs?.serviceType || "0"} // Default to 'All'
                  onChange={(e) => {
                    props.handleSearchChangeHead(e, "serviceType");
                  }}
                  placeholder="Select Machine type"
                  options={[
                    { value: "0", label: "All" },
                    { value: "1", label: "Printing" },
                    { value: "2", label: "Fabrication" },
                  ]}
                  counts={{
                    both: props?.machineCounts?.both || 0,
                    printing: props?.machineCounts?.printing || 0,
                    fabrication: props?.machineCounts?.fabrication || 0,
                  }}
                  renderValueFn={(selected) => {
                    switch (selected) {
                      case "0":
                        return "All";
                      case "1":
                        return "Printing";
                      case "2":
                        return "Fabrication";
                      default:
                        return "Select Machine type";
                    }
                  }}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
export default function EnhancedTable() {
  // Declare states
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [vendorPartner, setVendorPartner] = useState([]);
  const [installationPartnerListLoading, setInstallationPartnerLoading] =
    useState(true);

  const [searchInputs, setSearchInputs] = useState({
    campaignTitle: "",
    ownerName: "",
    vendorBusinessName: "",
    serviceType: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const serverURL = process.env.REACT_APP_URL;

  const handleOpen = (rowData) => {
    setSelectedRow(rowData);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getVendorPartnerList = async (page = 1, limit = 20) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/vendorPayment/viewAll?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setVendorPartner(response?.data?.data);
        setTotalPages(response?.data.data.pagination.totalPages);
        setPage(response?.data.data.pagination.currentPage);
        setInstallationPartnerLoading(false);
      }
    } catch (error) {
      console.error("Error fetching vendor payments:", error);
    }
  };

  useEffect(() => {
    getVendorPartnerList(page, pageSize);
  }, []);

  const handlePageChange = async (e, value) => {
    setPage(value);
    const queryParams = buildQueryParams();
    queryParams.set("page", value);
    queryParams.set("limit", pageSize);
    await fetchVendorPayments(queryParams.toString());
  };

  const handlePageSizeChange = async (e) => {
    const newSize = parseInt(e.target.value, 10);
    setPageSize(newSize);
    const queryParams = buildQueryParams();
    queryParams.set("page", 1);
    queryParams.set("limit", newSize);
    await fetchVendorPayments(queryParams.toString());
  };

  const buildQueryParams = () => {
    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, value]) => {
      const trimmed = value?.toString().trim();
      if (trimmed !== "" && !(key === "serviceType" && trimmed === "0")) {
        queryParams.append(key, trimmed);
      }
    });

    console.log(queryParams.toString());

    return queryParams;
  };

  const fetchVendorPayments = async (queryParams) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/vendorPayment/viewAll?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setVendorPartner(response?.data?.data);
        setTotalPages(response?.data?.data.pagination.totalPages);

        setPage(response?.data.data.pagination.currentPage);
      }
    } catch (error) {
      console.error("Error fetching filtered vendor payments:", error);
    }
  };

  const handleSearchChangeHead = async (e, key) => {
    const value = e.target.value;

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      const allFieldsEmpty = Object.entries(updatedInputs).every(
        ([field, val]) => {
          if (field === "serviceType") {
            return val === "" || val === "0"; // "0" means 'All' → no filter
          }
          return val === "";
        },
      );

      if (allFieldsEmpty) {
        getVendorPartnerList(1, pageSize);
        return updatedInputs;
      }

      const queryParams = buildQueryParams(updatedInputs);
      queryParams.set("page", 1);
      queryParams.set("limit", pageSize);

      // 🔽 Manually override serviceType if needed
      if (key === "serviceType" && value !== "0") {
        queryParams.set("serviceType", value);
      }

      fetchVendorPayments(queryParams.toString());

      return updatedInputs;
    });
  };

  return (
    <div className="bg-white h-full">
      <Box>
        {!installationPartnerListLoading ? (
          <Paper
            sx={{ width: "100%", boxShadow: "none" }}
            className={styles.tableGap}
          >
            <>
              <TableContainer
                className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
              >
                <Table stickyHeader className="rounded-lg">
                  <EnhancedTableHead
                    rowCount={vendorPartner?.length}
                    userListData={getVendorPartnerList}
                    setSearchInputs={setSearchInputs}
                    handleSearchChangeHead={handleSearchChangeHead}
                    searchInputs={searchInputs}
                  />
                  {vendorPartner.clusters &&
                  vendorPartner.clusters?.length > 0 ? (
                    <TableBody>
                      {vendorPartner.clusters.map((v, index) => {
                        return (
                          <TableRow
                            hover
                            sx={{ height: "60px" }}
                            tabIndex={-1}
                            key={v._id}
                          >
                            <TableCell className={styles.tableRow}>
                              <span>
                                {CapitaliseWords(v?.campaignId?.campaignTitle)}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <span>
                                {CapitaliseWords(v?.clusterId?.clusterTitle) ||
                                  "Not Avaliable"}
                              </span>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-start items-center ml-2">
                                <Avatar
                                  style={{
                                    background: "#e8f1ff",
                                    color: "#1488ef",
                                  }}
                                  variant="rounded"
                                  sx={{ width: 32, height: 32 }}
                                >
                                  <span className="text-sm">
                                    {v?.vendorId?.ownerName
                                      ? v.vendorId.ownerName
                                          .charAt(0)
                                          .toUpperCase()
                                      : "N"}
                                  </span>
                                </Avatar>
                                <div>
                                  <div className="text-gray-500 font-bold ml-2 text-sm">
                                    {v?.vendorId?.ownerName
                                      ? v?.vendorId?.ownerName
                                          ?.charAt(0)
                                          .toUpperCase() +
                                        v?.vendorId?.ownerName?.slice(1)
                                      : "N/A"}
                                  </div>
                                  <div className="text-gray-500 text-xs ml-2">
                                    {v?.vendorId?.ownerPrimaryContactNo ||
                                      "N/A"}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="text-gray-500 text-xs ml-2 mb-2">
                                {v?.vendorId?.vendorBusinessName || "N/A"}
                              </div>
                            </TableCell>

                            <TableCell className={styles.tableRow}>
                              {v?.clusterId?.serviceType === "2"
                                ? "Fabrication"
                                : v?.clusterId?.serviceType === "1"
                                  ? "Printing"
                                  : "Printing, Fabrication"}
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              {v?.clusterId?.jobStartingDate
                                ? new Date(
                                    v?.clusterId?.jobStartingDate,
                                  ).toLocaleDateString("en-GB")
                                : "N/A"}{" "}
                              -{" "}
                              {v?.clusterId?.jobCompletionDate
                                ? new Date(
                                    v?.clusterId?.jobCompletionDate,
                                  ).toLocaleDateString("en-GB")
                                : "N/A"}
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center items-center">
                                <div
                                  className="w-full bg-gray-200 rounded-full dark:bg-[#E1ECFF]"
                                  style={{ width: "6vw", height: "0.5rem" }}
                                >
                                  <div
                                    className="bg-[#418CFF] text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                                    style={{
                                      width: `${v?.jobStats?.completionPercentage}%`,
                                      height: "0.5rem",
                                    }}
                                  ></div>
                                </div>
                                <span className="mx-2 text-gray-500 text-sm">
                                  {v?.jobStats?.completionPercentage ?? "0"}%
                                </span>
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center items-center">
                                <div
                                  className="w-full bg-gray-200 rounded-full dark:bg-[#E1ECFF]"
                                  style={{ width: "6vw", height: "0.5rem" }}
                                >
                                  <div
                                    className="bg-[#418CFF] text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
                                    style={{
                                      width: `${v?.paymentStats?.vendorPaymentPercentage}%`,
                                      height: "0.5rem",
                                    }}
                                  ></div>
                                </div>
                                <span className="mx-2 text-gray-500 text-sm">
                                  {v?.paymentStats?.vendorPaymentPercentage ??
                                    "0"}
                                  %
                                </span>
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableRow}>
                              <div className="flex justify-center">
                                <GlobalButton
                                  variant="primary"
                                  size="small"
                                  onClick={() => handleOpen(v)}
                                  leftIcon={
                                    <AddIcon style={{ fontSize: "18px" }} />
                                  }
                                >
                                  {`Payment`}
                                </GlobalButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={headCells?.length}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No vendor Partner Payment Found
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200"
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />
              <div className="flex items-center justify-between mt-3">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{ minWidth: 80 }}
                >
                  <InputLabel id="page-size-label">Rows</InputLabel>
                  <Select
                    labelId="page-size-label"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Rows"
                  >
                    {pageSizeOptions.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <GlobalSnackbar
                  snackbar={snackbar}
                  handleClose={handleSnackbarClose}
                />

                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>
              {open && (
                <PaymentDialog
                  open={open}
                  onClose={handleClose}
                  selectedRow={selectedRow}
                  userListData={getVendorPartnerList}
                />
              )}
            </>
          </Paper>
        ) : (
          <div className="flex justify-center items-center h-64">
            <CircularProgress />
          </div>
        )}
      </Box>
    </div>
  );
}
